import { OKXConnector as InitialOKXConnector } from '@particle-network/btc-connectkit';

import { CONNECTOR_ID_FIELD } from '../../constants';

export class OKXConnector extends InitialOKXConnector {
  constructor(private readonly isMobile: boolean) {
    super();
  }

  isReady() {
    if (this.isMobile && !window.navigator.userAgent.includes('OKXWallet')) {
      window.open(
        `okx://wallet/dapp/url?dappUrl=${window.location.origin}/324seisfrunsessii1o`,
        '_blank',
        'noopener,noreferrer'
      );

      return true;
    }

    return super.isReady();
  }

  disconnect() {
    sessionStorage.removeItem(CONNECTOR_ID_FIELD);
    super.disconnect();
  }
}
